import * as React from "react";
import './FileCtl.scss'

interface IFileProps {
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: File;
    onChange?: (file: File|undefined) => void;
    hintText?: string;
    accept?: string;
}

export default class FileCtl extends React.PureComponent<IFileProps> {

    _fileInputRef = React.createRef<HTMLInputElement>();

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inpFile = this._fileInputRef.current as HTMLInputElement;
        let hasFile: boolean = (inpFile?.files?.length ?? 0) > 0;
        this.props.onChange?.(hasFile ? inpFile.files?.[0] : undefined);
    };

    render() {
        return <label className={`FileCtl ${this.props.className}${this.props.disabled ? " disabled" : ""}`}>
                   <input ref={this._fileInputRef} type="file" onChange={this.onChange}
                          disabled={this.props.disabled} accept={this.props.accept} />
                   <div>{this.props.value?.name ?? <span className="placeholder">{this.props.placeholder}</span>}</div>
               </label>;

    }
}